import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TableItem from './TableItem';
import BookingModal from './BookingModal';
import { BOOKING_STATUS } from '../../../../constants/enums';
import './css/TableMap.css';

export default function TableMap({ tables, bookings, onUpdateTableStatus, onUpdateBookingStatus }) {
  const { t } = useTranslation();
  const [selectedTable, setSelectedTable] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleTableClick = (table) => {
    setSelectedTable(table);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedTable(null);
  };

  const getBookingForTable = (tableId) => {
    return bookings.find(booking =>
    booking.tables.some(table => table.tableId === tableId)
  ) || null;
  };

  const hasBooking = (tableId) => {
    const booking = getBookingForTable(tableId);
    return booking !== null && booking.status !== BOOKING_STATUS.COMPLETED && booking.status !== BOOKING_STATUS.CANCELLED;
  };

  return (
    <div className="table-map-container">
      <div className="table-layout">
        {/* outside section border */}
        <div className="section-border outside-section">
            {tables
            .filter((table) => table.tableId >= 20 && table.tableId <= 29)
            .map((table) => (
                <TableItem
                key={table.tableId}
                table={table}
                hasBooking={hasBooking(table.tableId)}
                onClick={handleTableClick}
                />
            ))}
        </div>
        
        {/* Center section border */}
        <div className="section-border inside-section">
            <div className="section-border top-inside-section">
                {tables
                .filter((table) => table.tableId >= 16 && table.tableId <= 19)
                .map((table) => (
                    <TableItem
                    key={table.tableId}
                    table={table}
                    hasBooking={hasBooking(table.tableId)}
                    onClick={handleTableClick}
                    />
                ))}
            </div>
            <div className="section-border center-inside-section">
                {tables
                .filter((table) => table.tableId >= 12 && table.tableId <= 15)
                .map((table) => (
                    <TableItem
                    key={table.tableId}
                    table={table}
                    hasBooking={hasBooking(table.tableId)}
                    onClick={handleTableClick}
                    />
                ))}
            </div>
            <div className="section-border bottom-inside-section">
                {tables
                .filter((table) => table.tableId >= 3 && table.tableId <= 11)
                .map((table) => (
                    <TableItem
                    key={table.tableId}
                    table={table}
                    hasBooking={hasBooking(table.tableId)}
                    onClick={handleTableClick}
                    />
                ))}
            </div>
            {/* Sushi Bar */}
            <div className="section-border sushi-inside-section">
                <div className="sushi-bar">
                    <div className="sushi-bar-title">{t('admin.table_management.map.sushi_bar')}</div>
                </div>
                    {tables
                    .filter((table) => table.tableId >= 1 && table.tableId <= 2)
                    .map((table) => (
                        <TableItem
                        key={table.tableId}
                        table={table}
                        hasBooking={hasBooking(table.tableId)}
                        onClick={handleTableClick}
                        />
                    ))}
            </div>
        </div>
    
        {/* Legend */}
        <div className="legend">
          <h4 className="legend-title">{t('admin.table_management.map.legend.title')}</h4>
          <div className="legend-items">
            <div className="legend-item">
              <div className="legend-color legend-available"></div>
              <span>{t('admin.table_management.map.legend.available')}</span>
            </div>
            <div className="legend-item">
              <div className="legend-color legend-in-service"></div>
              <span>{t('admin.table_management.map.legend.in_service')}</span>
            </div>
            <div className="legend-item">
              <div className="legend-color legend-out-of-service"></div>
              <span>{t('admin.table_management.map.legend.out_of_service')}</span>
            </div>
          </div>
        </div>
      </div>

      <BookingModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        table={selectedTable}
        booking={selectedTable ? getBookingForTable(selectedTable.tableId) : null}
        onUpdateTableStatus={onUpdateTableStatus}
        onUpdateBookingStatus={onUpdateBookingStatus}
      />
    </div>
  );
}